import { useEffect, useRef, useState } from 'react'

const useNavbar = () => {
    const [showNavbar, setShowNavbar] = useState(false)
    // SSR/prerender-safe: start with deterministic value to avoid hydration mismatch.
    // Real viewport size is read in useEffect below, after hydration completes.
    const [isMobile, setIsMobile] = useState(false)
    const [isInHero, setIsInHero] = useState(true)
    const rafScroll = useRef(0)
    const resizeTimer = useRef(0)

    useEffect(()=>{
        // Skip during prerender (puppeteer/HeadlessChrome) so prerendered HTML
        // matches the client's first render exactly (avoids React #418/#423).
        if (typeof navigator !== 'undefined' && navigator.userAgent.includes('HeadlessChrome')) return;
        let mobileRef = window.innerWidth <= 950;
        setIsMobile(mobileRef);

        const update = () => {
            const scrollY = window.scrollY;
            const mobile = mobileRef;

            if (mobile) {
                // Mobile bar is always shown; only track "scrolled" for a shadow
                setIsInHero(scrollY < 20);
            } else {
                setIsInHero(scrollY < 600);
                setShowNavbar(scrollY > 150);
            }
        };

        const handleScroll = () => {
            if (rafScroll.current) return;
            rafScroll.current = requestAnimationFrame(() => {
                rafScroll.current = 0;
                update();
            });
        };

        const handleResize = () => {
            clearTimeout(resizeTimer.current);
            resizeTimer.current = setTimeout(() => {
                mobileRef = window.innerWidth <= 950;
                setIsMobile(mobileRef);
            }, 150);
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        window.addEventListener("resize", handleResize, { passive: true });
        update();

        return () => {
            cancelAnimationFrame(rafScroll.current);
            clearTimeout(resizeTimer.current);
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        }
    },[])

  return {showNavbar, isMobile, isInHero}
}

export default useNavbar
